module.exports = {
  "id": "wander",
  "color": "green",
  "title": "wander",
  "icon": "wander",
  "category": "movement",
  "description": "Make a piece move around randomly.",
  "exposedVariables": [
    {
      "variableName": "Wander Speed",
      "spriteName": "$glitch_target",
      "tooltip":"Set the speed this piece will wander around",
      "value": 1,
      "input": {
        "type": "slider",
        "max": 5,
        "step": 0.1,
        "min": "0.1"
      }
    },
    {
      "variableName": "Wander Amount",
      "spriteName": "$glitch_target",
      "tooltip":"Set the distance this piece will move around before changing direction",
      "value": 30,
      "input": {
        "type": "slider",
        "max": 100,
        "min": "1",
        "step": "1"
      }
    },
    {
      "variableName": "Wait Time",
      "spriteName": "$glitch_target",
      "tooltip": "Set the amount of time this piece will pause before changing direction",
      "value": 0.2,
      "input": {
        "type": "slider",
        "max": 5,
        "min": "0.1",
        "step": "0.1"
      }
    }
  ],
  "info": [
    {
      "text": "Make a piece move around randomly",
      "image": "provision/glitches/wander/wander.gif"
    }
  ],
  "codeImage": "provision/glitches/wander/wander.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/wander/wander.svg"
};